import { observer } from 'mobx-react'
import { TableCell } from 'components/Table'
import styles from './ServiceCell.sass'
import React from 'react'

interface ServiceCellProps {
  children: string
  detail?: string | null
}

export default observer(function ServiceCell({
  children,
  detail,
}: ServiceCellProps) {
  return (
    <TableCell>
      <div className={styles.service}>{children}</div>
      {detail && <div className={styles.detail}>{detail}</div>}
    </TableCell>
  )
})
